import moment from "moment";

export function removeIllegalChars (filename: string) {
  // Define the illegal characters for most operating systems
  const illegalChars = /[/:*?"<>|]/g; 

  // Replace all illegal characters with an underscore
  return filename.replace(illegalChars, '_'); 
}

//Misc Functions
export function calculateTimeAgo (date: Date) {
  if (!date) return '';

  return moment(date).fromNow();
};

export function formatDateForDisplay(date: Date) {
  if (!date) return '';
  return moment(date).format('MM/DD/YYYY @ HH:mm')
}

export function isFutureDate(date: Date) {
  if (!date) return '';
  return moment(date).isAfter(moment())
}